import React from 'react';

const TechPartnerSection = () => {
    return (
        <section className="w-full bg-[#FFFFFF] py-[60px] sm:py-[80px] lg:py-[100px] overflow-hidden select-none text-left relative z-10">
            <div className="max-w-[1440px] w-full mx-auto px-5 sm:px-10 lg:px-[80px]">

                <div style={{ background: "linear-gradient(180deg, #F3F5FF 0%, #E5ECFF 100%)" }} className="w-full grid lg:grid-cols-2 grid-cols-1 items-center relative overflow-hidden">

                    <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-[#D6E2FF]/20 blur-[100px] rounded-full pointer-events-none" />

                    <div className="w-full flex items-center justify-center lg:justify-start relative">
                        <div className="w-full max-w-[520px] aspect-[16/10] sm:aspect-[16/9] lg:aspect-[4/3] rounded-[18px] overflow-hidden mix-blend-multiply sm:mix-blend-normal">
                            <img
                                src="/assets/transforming/img1.png"
                                alt="Futuristic Glass Abstract Grid"
                                className="w-full h-full object-cover object-center transform transition-transform duration-700 hover:scale-103"
                            />
                        </div>
                    </div>

                    <div className="w-full lg:px-[60px] px-[20px] lg:py-[80px] py-[30px] flex flex-col items-start text-left relative z-10">


                        <h2 className="text-[#01386A] font-sora font-[600] text-[20px] lg:text-[30px] leading-[1.2] tracking-tight mb-6">
                            Your Trusted Technology Partner
                        </h2>

                        <div className="flex flex-col gap-4 max-w-[560px]">
                            <p className="text-[#49577A] font-graphik text-[14px] sm:text-[16px] leading-relaxed font-[500]">
                                At Strix Digital, we believe technology should simplify challenges and accelerate growth. We specialize in delivering innovative IT solutions that help businesses streamline operations, enhance customer experiences, and achieve digital transformation.
                            </p>
                            <p className="text-[#49577A] font-graphik text-[14px] sm:text-[16px] leading-relaxed font-[500]">
                                With a team of experienced developers, designers, and technology consultants, we turn ideas into impactful digital products that drive measurable business outcomes.
                            </p>
                        </div>

                    </div>

                </div>

            </div>
        </section>
    );
};

export default TechPartnerSection;